import { OperationAttainment, TreeNodeBase } from '../../types/interfaces';

export function convertOperationsOptionsToAttainments(
  operations: TreeNodeBase[]
): OperationAttainment[] {
  return operations
    .filter(op => op.key && (op as any).attainments && Array.isArray((op as any).attainments))
    .map(op => ({
      operationType: {
        id: parseInt(op.key),
        label: op.label
      },
      attainments: (op as any).attainments.map((att: any) => ({
        id: att.id,
        label: att.label || att.name,
        shortLabel: att.shortName || att.label || att.name
      }))
    }));
}
